function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "edit",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "edit-/-edit-copy",
  transform: "translate(1.000000, 2.000000)",
  fill: "#C2C2C2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.71898777,8.49999915 L-0.359146822,10.2317779 C-0.838900972,10.6315731 -0.838901777,11.3684248 -0.359147627,11.7682198 L1.71898777,13.4999992 L17.7189644,13.4999992 L17.7189644,8.49999915 L1.71898777,8.49999915 Z",
  id: "edit-/-edit",
  transform: "translate(11.000012, 10.999999) rotate(-45.000000) translate(-11.000012, -10.999999) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.7189873,13.4999992 C22.2712715,13.4999992 22.7189873,13.0522839 22.7189873,12.4999992 L22.7189873,9.49999915 C22.7189873,8.94771444 22.2712715,8.49999915 21.7189873,8.49999915 L18.7189644,8.49999915 L18.7189644,13.4999992 L21.7189873,13.4999992 Z",
  id: "edit-/-edit",
  transform: "translate(11.000012, 10.999999) rotate(-45.000000) translate(-11.000012, -10.999999) "
})));

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cb31b603.svg";
export { ForwardRef as ReactComponent };